import { EVENT_SOURCE } from 'b2b-apps/core/analytics/types/types';
import {
  ANALYZE_PRODUCT_ADD_TO_CART,
  ANALYZE_PRODUCT_CLICK,
  ANALYZE_PRODUCT_DETAILS_VIEW,
  ANALYZE_PRODUCT_WISHLIST_ADD,
  ANALYZE_PRODUCTS_ADD_TO_CART,
  ANALYZE_PRODUCTS_LIST_VIEW,
} from './actionTypes';
import {
  AnalyzeProductAddToCartAction,
  AnalyzeProductAddToWishlistAction,
  AnalyzeProductClickAction,
  AnalyzeProductDetailsPageViewAction,
  AnalyzeProductsAddToCartAction,
  AnalyzeProductsListViewAction,
} from './types';

export const analyzeProductDetailsPageView = (sku: string): AnalyzeProductDetailsPageViewAction => ({
  type: ANALYZE_PRODUCT_DETAILS_VIEW,
  payload: {
    sku,
  },
});

export const analyzeProductsListView = (data: {
  eventSource: EVENT_SOURCE;
  skus?: string[];
}): AnalyzeProductsListViewAction => ({
  type: ANALYZE_PRODUCTS_LIST_VIEW,
  payload: {
    eventSource: data.eventSource,
    skus: data.skus,
  },
});

export const analyzeProductClick = (data: {
  sku: string;
  listPosition?: number;
  additionalId?: string | number;
  eventSource: EVENT_SOURCE;
}): AnalyzeProductClickAction => ({
  type: ANALYZE_PRODUCT_CLICK,
  payload: {
    sku: data.sku,
    listPosition: data.listPosition,
    additionalId: data.additionalId,
    eventSource: data.eventSource,
  },
});

export const analyzeProductAddToWishlist = (sku: string, eventSource: EVENT_SOURCE):
  AnalyzeProductAddToWishlistAction => ({
  type: ANALYZE_PRODUCT_WISHLIST_ADD,
  payload: {
    sku,
    eventSource,
  },
});

export const analyzeProductAddToCart = (data: {
  sku: string;
  listPosition?: number;
  additionalId?: string | number;
  eventSource: EVENT_SOURCE;
}): AnalyzeProductAddToCartAction => ({
  type: ANALYZE_PRODUCT_ADD_TO_CART,
  payload: {
    sku: data.sku,
    listPosition: data.listPosition,
    additionalId: data.additionalId,
    eventSource: data.eventSource,
  },
});

export const analyzeProductsAddToCart = (data: {
  products?: { sku: string, listPosition: number }[];
  additionalId?: string | number;
  eventSource: EVENT_SOURCE;
}): AnalyzeProductsAddToCartAction => ({
  type: ANALYZE_PRODUCTS_ADD_TO_CART,
  payload: {
    products: data.products,
    additionalId: data.additionalId,
    eventSource: data.eventSource,
  },
});
